<template>
  <message-box
    :yes-no="schvalenieActionDialog.yesNo"
    :title="schvalenieActionDialog.title"
    :text="schvalenieActionDialog.text"
    v-model="schvalenieActionDialog.open"
    :action="schvalenieActionDialog.action"
    :hide-cancel="schvalenieActionDialog.hideCancel"
  />
</template>
<script>
import MessageBox from '../basic/MessageBox';
import protectedAxios from '../../auth/axios.js';
import { mapGetters, mapMutations } from 'vuex';
import { eventBus } from '../../main.js';

export default {
  props: {
    cisloObchPripadu: null,
    cisloPredmetu: null,
    newId: null,
    formaPodnikania: null,
    isNeadresnaPonuka: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MessageBox,
  },
  data() {
    return {
      varianty: [],
      schvalenieActionDialog: {
        yesNo: false,
        open: false,
        title: ``,
        text: '',
        action: null,
        hideCancel: true,
      },
    };
  },
  computed: {
    ...mapGetters(['odoslatNaSchvalenieRequest','jeDealer']),
    ...mapGetters('variables',['isExtSuhlasyDisplayed']),
  },
  methods: {
    ...mapMutations(['setOdoslatNaSchvalenieRequest','setLoadingDialog']),
    async execute(varianty, kontrolaPoPresmerovani = false) {
      if(this.newId){
        this.$emit("setValid",{value: true, property: 'spustenieOdosielaniaNaSchvalenie', message: '', showProgress: false, isError: true});
        this.varianty = varianty;
        return await this.kontrolaSchvaleniaVariantu(varianty[0], kontrolaPoPresmerovani).then(async (res) => {
          if(res === false){
            return Promise.resolve(false);
          }
          if(this.formaPodnikania?.pkId == 3 && this.varianty.length > 1){
            const scoringResults = await Promise.all(
              this.varianty
                .slice(1)
                .map(variant => this.kontrolaScoring(variant, kontrolaPoPresmerovani))
            );
            if (!scoringResults.every(result => result === true)) {
              return false;
            }
          }
          this.openSumar();
          return Promise.resolve(true);
        }).catch((e) => {
          return Promise.reject(e);
        });
      }
    },
    async kontrolaSchvaleniaVariantu(variant, kontrolaPoPresmerovani = false){
      return await protectedAxios
          .post(
            `sumar/varianty/kontrola-schvalenia?newId=${this.newId}&idVariantu=${variant.pkid}`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            //this.schvalenieErrors = res.data;
            if (res.data.length > 0) {
              let errors = res.data.sort((a, b) => {
                return a.severity - b.severity;
              });
              let dodavatel_info_predmety = [];
              let zmena_dodavatela_predmety = [];
              for (let i = 0; i < errors.length; i++) {
                switch (errors[i].validation_type) {
                  case 'predmet':
                    this.setLoadingDialog();
                    this.openPredmetDialog(errors[i].chyba,errors[i].cislo_predmetu);
                    return false;
                  case 'najomca_nevyplnene_udaje':
                    this.setLoadingDialog();
                    this.openNajomcaDialog(errors[i].chyba, errors[i].pravo_adresna_ponuka == 1);
                    return false;
                  case 'kontrola_ko':
                    this.setLoadingDialog();
                    this.openKODialog(errors[i].chyba);
                    return false;
                  case 'suhlasy':
                    this.setLoadingDialog();
                    this.openSuhlasyDialog(errors[i].chyba, errors[i].pravo_adresna_ponuka == 1, kontrolaPoPresmerovani);
                    return false;
                  case 'ext_suhlasy':
                    if(kontrolaPoPresmerovani || !this.isExtSuhlasyDisplayed){
                      this.setLoadingDialog();
                      this.openSuhlasyDialog(errors[i].chyba, errors[i].pravo_adresna_ponuka == 1, kontrolaPoPresmerovani);
                      return false;
                    }
                    return true;
                  case 'dodatocne_info':
                    this.setLoadingDialog();
                    this.openDodatInfoDialog(errors[i].chyba, kontrolaPoPresmerovani);
                    return false;
                  case 'dodavatel_info':
                    dodavatel_info_predmety.push(errors[i].cislo_predmetu);
                    break;
                  case 'zmena_dodavatela':
                    zmena_dodavatela_predmety.push(errors[i].cislo_predmetu);
                    break;
                }
              }
              if(dodavatel_info_predmety.length > 0){
                this.setLoadingDialog();
                this.openDodavatelInfoDialog(dodavatel_info_predmety);
                return false;
              }
              if(zmena_dodavatela_predmety.length > 0){
                this.setLoadingDialog();
                this.changeZmenaDodavatela(zmena_dodavatela_predmety);
                return false;
              }
            }
            return true;
          })
          .catch(e => {
            if (e != null && e != '') {
              console.log(e);
              eventBus.$emit('snack-error', 'Pri kontrole schvalenia nastala chyba: ' + e);
            }
            return false;
          });
    },
    async kontrolaScoring(variant, kontrolaPoPresmerovani = false){
      return await protectedAxios
          .post(
            `sumar/varianty/kontrola-scoringu`,
            {
              newId: this.newId,
              idVariantu: variant.pkid 
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          ).then((res) => {
            if(res.data == 0){
              this.setLoadingDialog();
              this.openDodatInfoDialog(
                "Pre odoslanie ponuky na schválenie je potrebné vyplniť dodatočné informácie. Prajete si vyplniť dodatočné informacie.",
                kontrolaPoPresmerovani
              );
              return false;
            }
          }).then(result => result !== false)
    },
    
    openObchodnePripadyGrid() {
      this.$router.push(`/obchodne-pripady`);
    },
    openNajomca() {
      if (this.varianty.length > 0) {
        this.setOdoslatNaSchvalenieRequest({
          cisloObchPripadu: this.cisloObchPripadu,
          cisloPredmetu: this.cisloPredmetu,
          varianty: this.varianty,
          newId: this.newId
        });
        this.$router.push(`/obchodny-pripad/${this.newId}/najomca`);
      }
    },
    openPredmet(cislo_predmetu) {
      if (this.varianty.length > 0) {
        this.setOdoslatNaSchvalenieRequest({
          cisloObchPripadu: this.cisloObchPripadu,
          cisloPredmetu: this.cisloPredmetu,
          varianty: this.varianty,
          newId: this.newId
        });
        this.$router.push(
          `/obchodny-pripad/${this.newId}?cislo_predmetu=${
            cislo_predmetu
          }`
        );
      }
    },
    openSumar() {
      let _newId = null;
      if (this.odoslatNaSchvalenieRequest.newId) {
        _newId = this.odoslatNaSchvalenieRequest.newId;
      } else {
        _newId = this.newId;
      }
      if (_newId && this.$route.name != 'pripadSumar' && this.$route.name != 'pripadSumarNajomca' && this.$route.name != 'pripadSumarDodatInfo'){
        this.$router.push(`/obchodny-pripad/${_newId}/sumar`);
      }else{
        if(this.$route.name == 'pripadSumarNajomca' || this.$route.name == 'pripadSumarDodatInfo'){
          this.$emit("sumarChangeTab",0);
        }
      }
    },
    openSumarNajomca() {
      if (this.isNeadresnaPonuka) {
        return;
      }
      if (this.varianty.length > 0) {
        this.setOdoslatNaSchvalenieRequest({
          cisloObchPripadu: this.cisloObchPripadu,
          cisloPredmetu: this.cisloPredmetu,
          varianty: this.varianty,
          newId: this.newId
        });
        if (this.newId && this.$route.name != 'pripadSumar' && this.$route.name != 'pripadSumarNajomca' && this.$route.name != 'pripadSumarDodatInfo'){
          this.$router.push(
            `/obchodny-pripad/${this.newId}/sumar/najomca`
          );
        }else{
          this.$emit("sumarChangeTab",1);
        }
      }
    },
    openSumarDodatInfo() {
      if (this.isNeadresnaPonuka) {
        return;
      }
      this.setOdoslatNaSchvalenieRequest({
          cisloObchPripadu: this.cisloObchPripadu,
          cisloPredmetu: this.cisloPredmetu,
          varianty: this.varianty,
          newId: this.newId
        });
      if (this.varianty.length > 0) {
        if (this.newId && this.$route.name != 'pripadSumar' && this.$route.name != 'pripadSumarNajomca' && this.$route.name != 'pripadSumarDodatInfo'){
          this.$router.push(
            `/obchodny-pripad/${this.newId}/sumar/dodatInfo`
          );
        }else{
          this.$emit("sumarChangeTab",2);
        }
      }
    },
    openKODialog(title) {
      this.schvalenieActionDialog.yesNo = false;
      this.schvalenieActionDialog.title = title;
      this.schvalenieActionDialog.text = '';
      this.schvalenieActionDialog.action = this.openObchodnePripadyGrid;
      this.schvalenieActionDialog.hideCancel = true;
      this.schvalenieActionDialog.open = true;
    },
    openSuhlasyDialog(title, pravoAdresnaPonuka, kontrolaPoPresmerovani = false) {
       if (!pravoAdresnaPonuka) {
        this.schvalenieActionDialog.yesNo = false;
        this.schvalenieActionDialog.title = title;
        this.schvalenieActionDialog.text = '';
        this.schvalenieActionDialog.action = null;
        this.schvalenieActionDialog.hideCancel = true;
        this.schvalenieActionDialog.open = true;
        return;
      }
      if(this.jeDealer && !kontrolaPoPresmerovani){
        this.schvalenieActionDialog.yesNo = false;
        this.schvalenieActionDialog.title = title;
        this.schvalenieActionDialog.text = '';
        this.schvalenieActionDialog.action = this.openSumarNajomca;
        this.schvalenieActionDialog.hideCancel = true;
        this.schvalenieActionDialog.open = true;
      }else{
        this.$emit("setValid",{value: true, property: 'spustenieOdosielaniaNaSchvalenie', message: title, showProgress: false, isError: true});
        this.openSumarNajomca();
      }
    },
    openPredmetDialog(title,cislo_predmetu) {
      this.schvalenieActionDialog.hideCancel = false;
      this.schvalenieActionDialog.yesNo = true;
      this.schvalenieActionDialog.title = title;
      this.schvalenieActionDialog.action = () => this.openPredmet(cislo_predmetu);
      this.schvalenieActionDialog.open = true;
    },
    openNajomcaDialog(title, pravo_adresna_ponuka) {
      if (this.isNeadresnaPonuka) {
        this.schvalenieActionDialog.title = title;
        this.schvalenieActionDialog.hideCancel = true;
        this.schvalenieActionDialog.yesNo = false;
        this.schvalenieActionDialog.action = null;
        this.schvalenieActionDialog.open = true;
        return;
      }
      this.schvalenieActionDialog.title = title;
      if (pravo_adresna_ponuka) {
        this.schvalenieActionDialog.hideCancel = false;
        this.schvalenieActionDialog.yesNo = true;
        this.schvalenieActionDialog.action = this.openNajomca;
      } else {
        this.schvalenieActionDialog.hideCancel = true;
        this.schvalenieActionDialog.yesNo = false;
        this.schvalenieActionDialog.action = null;
      }
      this.schvalenieActionDialog.open = true;
    },
    openDodatInfoDialog(title, kontrolaPoPresmerovani = false) {
       if (this.isNeadresnaPonuka) {
        return;
      }
      if(this.jeDealer && !kontrolaPoPresmerovani){
        this.schvalenieActionDialog.title = title;
        this.schvalenieActionDialog.hideCancel = false;
        this.schvalenieActionDialog.yesNo = true;
        this.schvalenieActionDialog.action = this.openSumarDodatInfo;
        this.schvalenieActionDialog.open = true;
      }else{
        if(this.formaPodnikania?.pkId != 2){
          this.$emit("setValid",{value: true, property: 'spustenieOdosielaniaNaSchvalenie', message: title, showProgress: false, isError: true});
        }
        this.openSumarDodatInfo();
      }
    },
    openDodavatelInfoDialog(dodavatel_info_predmety){
      if(dodavatel_info_predmety.length > 0){
        if (this.newId && this.$route.name != 'pripadSumar' && this.$route.name != 'pripadSumarNajomca' && this.$route.name != 'pripadSumarDodatInfo'){
          this.setOdoslatNaSchvalenieRequest({
            cisloObchPripadu: this.cisloObchPripadu,
            cisloPredmetu: this.cisloPredmetu,
            varianty: this.varianty,
            newId: this.newId
          });
          this.$router.push(
            `/obchodny-pripad/${this.newId}/sumar`
          );
        }else{
          this.$emit("openDodavatelInfoDialog",dodavatel_info_predmety);
        }
      }
    },
    changeZmenaDodavatela(zmena_dodavatela_predmety){
      if(zmena_dodavatela_predmety.length > 0){
      if (this.newId && this.$route.name != 'pripadSumar' && this.$route.name != 'pripadSumarNajomca' && this.$route.name != 'pripadSumarDodatInfo'){
          this.setOdoslatNaSchvalenieRequest({
            cisloObchPripadu: this.cisloObchPripadu,
            cisloPredmetu: this.cisloPredmetu,
            varianty: this.varianty,
            newId: this.newId
          });
          this.$router.push(
            `/obchodny-pripad/${this.newId}/sumar`
          );
        }else{
          this.$emit("updateZmenaDodavatela",zmena_dodavatela_predmety);
        }
      }
    },
  },
};
</script>
